<template>
  <div class="full-m-echart-body">
    <div id="mEchart" style="width: 100%; height: 336px"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "Chart",
  props: {
    rowData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.setEchart();
  },
  created() {},
  methods: {
    setEchart() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("mEchart"));
      // 指定图表的配置项和数据
      const option = {
        title: {
          text: "80",
          subtext: "总人数",
          x: "center",
          y: "40%",
          textStyle: {
            color: "#fff",
            fontSize: 22,
            lineHeight: 10,
          },
          subtextStyle: {
            color: "#fff",
            fontSize: 16,
            lineHeight: 10,
          },
        },
        itemStyle: {
          borderRadius: 10,
          borderColor: "#fff",
          borderWidth: 2,
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            color: ["#83f96d", "#1DB7E5", "#FE5050"], //'#FBFE27','rgb(11,228,96)','#FE5050'
            data: [
              {
                value: 10,
                name: "离寝",
              },
              {
                value: 60,
                name: "在寝",
              },
              {
                value: 12,
                name: "请假",
              },
            ],
            label: {
              alignTo: "edge",
              formatter: ["{c|{c}}", "{b|{b}}"].join("\n"),
              minMargin: 5,
              edgeDistance: 10,
              rich: {
                c: {
                  color: "rgb(241,246,104)",
                  fontSize: 20,
                  fontWeight: "bold",
                  lineHeight: 5,
                },
                b: {
                  color: "rgb(255,255,255)",
                  fontSize: 14,
                  height: 44,
                },
              },
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: "rgb(98,137,169)",
                },
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
.full-m-echart-body {
  padding: 20px 15px 15px 15px;
  height: 100%;
  overflow: hidden;
}
</style>
